class CheckboxController {
	$onInit() {
		this.value = this.value || false;
		//Creating dinamic id for component
		this.componentId = 'checkbox_' + (new Date().getTime() + Math.random());
	}

	/*
     * Fire callback function
     */
	changeValue() {
		this.onChange({
			$event: {
				value: this.value
			}
		});
	}
}

export default CheckboxController;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/checkbox/checkbox.controller.js